import { Badge } from "@george-labs.com/design-system"
import { LoanCaseStatusDTO } from "@smartx/mikro-vt-client-api"
import { useStatusBadge } from "../../hooks/useStatusBadge"

interface StatusBadgeProps {
  loanCaseStatus?: LoanCaseStatusDTO
  caseId?: string
}

const StatusBadge = ({ loanCaseStatus, caseId }: StatusBadgeProps) => {
  const { variant, icon, text } = useStatusBadge(loanCaseStatus, caseId)

  return (
    <Badge variant={variant} icon={icon}>
      {text}
    </Badge>
  )
}

export default StatusBadge
